import axios from 'axios';
import * as constants from './constants';

const instance = axios.create({
  baseURL: constants.BASE_URL,
});

export default instance;



// WEBPACK FOOTER //
// ./src/config/axios.js